//import references
import { Component } from 'react';

import { CircularProgress, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import 'react-toastify/dist/ReactToastify.css';

import DataGrid, {
  Column,
  Paging,
  RowDragging,
  Scrolling,
  Sorting
} from 'devextreme-react/data-grid';
import { ApiData } from "../config";

let daysData;


class SelectDaysPersonalized extends Component {

  constructor(props) {
    super(props);
    this.onReorder = this.onReorder.bind(this);
    this.state = {
      data: [['Loading Data...']],
      loading: false,
      dragWebPOIsKeys: [],
      selectedDaysPersonalized: [{ "id": '', "name": "Loading...", "country": "" },],
      defaultSelectedRow: [0, 1, 3]
    };
  }

  onReorder(e) {
    const visibleRows = e.component.getVisibleRows();
    const newDays = [...this.props.selectedDaysPersonalized];
    const toIndex = newDays.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = newDays.indexOf(e.itemData);

    newDays.splice(fromIndex, 1);
    newDays.splice(toIndex, 0, e.itemData);
    this.props.setSelectedDays(newDays);
    /*  this.setState({
       selectedDaysPersonalized: newDays,
     }); */
  }


  onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
    // this.selectionChangedBySelectBox = false;
    this.setState({
      dragWebPOIsKeys: selectedRowKeys,
    });
  };
  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.setState({ loading: true });
    this.xhrRequest().then((data) => {
      this.setState({ data, loading: false });
    });
  };
  xhrRequest = (url) => {
    return new Promise((resolve, reject) => {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
      };


      fetch(ApiData.apiUrl + '/days?take=5000', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          data.results.sort((a, b) => a.id - b.id);
          daysData = data.results;
          for (let i = 0; i < daysData.length; i++) {
            for (let j = 0; j < this.props.selectedDaysPersonalized.length; j++) {
              if (this.props.selectedDaysPersonalized[j].id === daysData[i].id) {
                daysData[i].selected1 = true;
              }
            }
          }
          resolve(data.results);
          this.setselectedRecord();
        });
    });
  };


  setselectedRecord() {
    let selectedDaysPersonalized1 = [...this.props.selectedDaysPersonalized];
    let defaultSelectedRow1 = [];
    for (let i = 0; i < daysData.length; i++) {
      if (daysData[i].selected1) {
        let flg = 1
        for (let j = 0; j < this.props.selectedDaysPersonalized.length; j++) {
          if (this.props.selectedDaysPersonalized[j].id === daysData[i].id) {
            flg = 0
          }
        }
        defaultSelectedRow1.push(i);
        if (flg === 1) {
          selectedDaysPersonalized1.push(daysData[i])
        }
      }

    }

    let selectedDaysPersonalizedNew = []

    for (let i = 0; i < selectedDaysPersonalized1.length; i++) {
      for (let j = 0; j < daysData.length; j++) {
        if ((daysData[j].id === selectedDaysPersonalized1[i].id) && daysData[j].selected1) {
          selectedDaysPersonalizedNew.push(daysData[j])
        }
      }
    }
    this.props.setSelectedDays(selectedDaysPersonalizedNew);
    this.setState({ defaultSelectedRow: defaultSelectedRow1 });
  }

  render() {
    const columns = [
      { name: 'id', options: { label: 'ID', filter: false, } },
      { name: 'internal_name', label: 'Internal Name', options: { filter: false } },
      { name: 'name', label: 'Name', options: { filter: false } },
      { name: 'country', label: 'Country' },
    ];

    const onRowsSelect = (curRowSelected, rowsSelected, rowMeta) => {
      /*  if (rowsSelected.length > 0) {
         selectedRowIndex = daysData[rowsSelected[0].dataIndex].id;
       } else {
         selectedRowIndex = false;
       } */
      if (daysData[curRowSelected[0].dataIndex].selected1) {
        daysData[curRowSelected[0].dataIndex].selected1 = false;
      }
      else {
        daysData[curRowSelected[0].dataIndex].selected1 = true;
      }
      this.setselectedRecord();
    };
    const { data } = this.state;

    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      download: false,
      print: false,
      selectableRowsOnClick: false,
      selectToolbarPlacement: 'none',
      rowsSelected: this.state.defaultSelectedRow,
      onRowSelectionChange: onRowsSelect,
    };

    return (
      <table>

        <tr>
          <td style={{ width: '40%' }}>
            <h4> Select Days: </h4>
          </td>
          <td style={{ width: '5%' }}>

          </td>
          <td style={{ width: '55%' }}>
            <h4> Order Selected days: </h4>
            <h6> Drag to order </h6>
          </td>
        </tr>

        <tr>
          <td style={{ width: '40%' }}>

            <div>
              <MUIDataTable
                title={
                  <Typography variant="subtitle2">
                    {this.state.loading && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: 'relative', top: 4 }}
                      />
                    )}
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
                rowsSelected={onRowsSelect}
                rowMeta={[0, 1]}
              />
            </div>
          </td>
          <td style={{ width: '10%' }}>

          </td>
          <td style={{ width: '45%', WebkitPaddingEnd: 100, verticalAlign: 'baseline' }} class="mytable">

            <DataGrid
              // height={440}
              dataSource={this.props.selectedDaysPersonalized}
              keyExpr="id"
              showBorders={true}
              ref={(ref) => (this.dataGrid = ref)}
              selectableRows={false}
              expandableRowsHeader={false}
              onSelectionChanged={this.onSelectionChanged}
              selectedRowKeys={this.state.dragWebPOIsKeys}
            >
              <RowDragging
                allowReordering={true}
                onReorder={this.onReorder}
                showDragIcons={true}
              />
              <Scrolling mode="virtual" />
              <Sorting mode="none" />
              <Column dataField="id" width={60} />
              <Column dataField="name" />
              <Column dataField="country" />
              <Paging defaultPageSize={10} />
            </DataGrid>

          </td>
        </tr>
      </table >
    );
  }
}
export default SelectDaysPersonalized;